import { render, staticRenderFns } from "./StokAnaliz.vue?vue&type=template&id=48a93205&scoped=true"
import script from "./StokAnaliz.vue?vue&type=script&lang=js"
export * from "./StokAnaliz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a93205",
  null
  
)

export default component.exports